<template>
  <div class="batch-setting">
    <Modal
      v-model="show"
      width="960"
      title="账单确认处理结果"
      :footer-hide="true"
      @on-cancel="handleCancel"
    >
      <div class="modal-main">
        <div v-if="loading" class="flex" style="margin-bottom: 12px">
          <Spin size="small"><Icon
            type="ios-loading"
            size="16"
            class="spin-icon-load"
          ></Icon></Spin><span style="margin-left: 10px">耐心等待，系统正在处理您的操作，请勿关闭当前页面</span>
        </div>
        <div class="table-main">
          <Table
            :columns="tableColumns"
            :data="tableData"
            max-height="500"
            border
          >
            <template slot="bankId" slot-scope="{ row }">
              <span>{{ getBankIdStr(row.bankId) }}</span>
            </template>
            <template slot="procSts" slot-scope="{ row }">
              <span :style="{ color: getProcStsColor(row.procSts) }">{{
                getProcStsStr(row.procSts)
              }}</span>
            </template>
          </Table>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import timer from '@/utils/timer.js';
export default {
  components: {

  },
  data() {
    return {
      show: false,
      tableData: [],
      loading: true,
      taskId: '',
      tableColumns: [
        {
          title: '账单编号',
          key: 'statementId',
          width: 250
        }, {
          title: '机构名称',
          key: 'orgName'
        }, {
          title: '结算月份',
          key: 'settleMonth',
          width: 130
        }, {
          title: '银行',
          slot: 'bankId',
          width: 130
        }, {
          title: '状态',
          slot: 'procSts',
          width: 160
        }
      ]
    };
  },
  created() {

  },
  destroyed() {
    timer.clearTimer('batchSettlementTask');
  },
  methods: {

    handleShow(id) {
      this.show = true;
      this.taskId = id;
      this.getTaskStatusList();
      timer.addTimer('batchSettlementTask', this.getTaskStatusList, 3000);
    },
    handleCancel() {
      timer.clearTimer('batchSettlementTask');
    },
    getBankTypeStr(val) {
      const map = {
        1: '平安银行',
        2: '花都工行',
        3: '微信商户'
      };
      return (val || val === 0) ? map[Number(val)] : '';
    },
    getBankIdStr(v) {
      const map = {
        '0': '微信商户',
        '10001': '平安银行',
        '10002': '花都工行',
        '10003': '中山工行'
      };
      return (v || v === 0) ? map[Number(v)] : '';
    },

    getProcStsStr(val) {
      const map = {
        0: '待处理',
        1: '确认成功',
        2: '账单确认处理中....',
        3: '确认失败'
      };
      return (val || val === 0) ? map[Number(val)] : '';
    },
    getProcStsColor(val) {
      const map = {
        0: '#515A6E',
        1: '#19be6b',
        2: '#02affe',
        3: 'red'
      };
      return (val || val === 0) ? map[Number(val)] : '';
    },
    async getTaskStatusList() {
      const params = {
        busiCode: 13, //  业务编码 3-批量结算账单
        pageSize: 100,
        pageNo: 1,
        // busiObjIds: [],
        upBatchIds: this.taskId ? [this.taskId] : [], // 父级任务id
        procStsList: this.taskId ? [] : [0, 2],
        exeFlag: 1
      };
      this.loading = true;
      const res = await courseSchedulCenter.getTaskStatusListApi(params);
      if (res.status == 200 && res.message.list.length > 0) {
        this.tableData = res.message.list.map(item => {
          return { ...item.properties, procSts: item.batchProcData.procSts };
        });
        this.checkTaskResult();
        // setTimeout(() => {
        //   this.checkTaskResult()
        // }, 1000)
      } else {
        this.loading = false;
        timer.clearTimer('batchSettlementTask');
      }
    },
    checkTaskResult() {
      const procIngs = this.tableData.filter(item => { return [0, 2].includes(Number(item.procSts)); });
      if (procIngs.length == 0) {
        localStorage.removeItem('batchSettlementTaskId');
        timer.clearTimer('batchSettlementTask');
        this.loading = false;
        if (this.taskId) {
          this.show = false;
          this.$emit('on-success', this.taskId);
        }
      }
    }

  }
};
</script>

<style>
</style>
